import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/utils/cn';

export interface SocialTabItem {
  id: string;
  label: string;
  to: string;
}

interface SocialTabNavProps {
  tabs: SocialTabItem[];
  className?: string;
}

export function SocialTabNav({ tabs, className }: SocialTabNavProps) {
  const location = useLocation();

  return (
    <nav
      className={cn(
        'flex gap-1 overflow-x-auto border-b border-slate-200 pb-px dark:border-slate-700',
        className,
      )}
      aria-label="Section tabs"
    >
      {tabs.map((tab) => {
        const [path, search] = tab.to.split('?');
        const active =
          location.pathname === path &&
          (search
            ? location.search === `?${search}` || location.search.includes(search.split('=')[1] ?? '')
            : !location.search || location.pathname === tab.to);
        const activeAlt = !search && (location.pathname === tab.to || location.pathname.startsWith(`${tab.to}/`));
        const isActive = search ? active : activeAlt;
        return (
          <Link
            key={tab.id}
            to={tab.to}
            className={cn(
              'shrink-0 rounded-t-lg px-3 py-2 text-sm font-medium transition',
              isActive
                ? 'border-b-2 border-primary-600 text-primary-700 dark:text-primary-300'
                : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-100',
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
